import apiClient from '@u/apiClient'
import router from '@/router'

import CheckActions from './check/actions'
import InvoiceItemAction from './invoiceItem/actions'
import PaymentActions from './payment/actions'
import fileDownload from 'js-file-download'

export default {
  ...CheckActions,
  ...InvoiceItemAction,
  ...PaymentActions,

  //region fetch
  /** Filters (companies, customers, statuses, fiscal years) of a document list. */
  async fetchInvoiceIndexMetadata({ commit }, doc_type) {
    await apiClient
      .get('api/invoicing/index-metadata', { params: { doc_type } })
      .then(async (response) => {
        await commit('setInvoiceMetadata', response.data.metadata)
      })
      .catch(() => {})
  },

  /**
   * A document list filtered by the API: `api/invoicing` (doc_type
   * required), `api/unpaid/invoicing` or `api/paid/invoicing` (doc_type and
   * status forced by the API). `filters` holds arrays of ids: company_id,
   * customer_id, status, fiscal_year. Accepts the bare doc_type, as before.
   */
  async fetchInvoiceIndex({ commit }, payload) {
    const {
      endpoint = 'api/invoicing',
      doc_type,
      filters = {}
    } = typeof payload === 'string' ? { doc_type: payload } : payload
    const params = doc_type ? { doc_type, ...filters } : { ...filters }
    await apiClient
      .get(endpoint, { params })
      .then(async (response) => {
        await commit('setInvoiceIndex', response.data.invoices)
      })
      .catch(() => {})
  },

  async fetchInvoiceID({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .get(`api/invoicing/${payload.id}`)
      .then(async (response) => {
        await commit('setInvoice', response.data.invoice)
        await commit('setInvoiceMetadata', response.data.metadata)
      })
      .catch(() => {})
  },
  async fetchNewInvoice({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })

    await apiClient
      .get(`api/model/new`, { params: { ...payload, model: 'invoice' } })
      .then(async (response) => {
        await commit('setInvoiceMetadata', response.data.metadata)
        await commit('setInvoice', response.data.invoice)
      })
      .catch((reason) => {
        console.error('fetchNewInvoice reason', reason)
      })
  },
  async fetchInvoiceActivitiesByInvoiceID({ commit }, payload) {
    await apiClient
      .get(`api/invoice/fetch-activities/${payload.invoice_id}`)
      .then(async (response) => {
        await commit('setInvoiceActivity', response.data.activities)
      })
      .catch(async (reason) => {
        await console.error(reason)
      })
  },

  //endregion

  //region store
  storeNewInvoice(_, payload) {
    return apiClient
      .post('api/invoicing', payload.invoice)
      .then(async (response) => {
        await router.push({
          name: 'invoice_info_route',
          params: { invoicing_id: response.data.data.id }
        })
        return response.data
      })
  },
  //endregion

  //region update
  updateInvoice(_, payload) {
    return apiClient
      .put(`api/invoicing/${payload.id}`, payload.invoice)
      .then(async (response) => {
        await router.push({
          name: 'invoice_info_route',
          params: { invoicing_id: response.data.data.id }
        })
        return response.data
      })
  },
  //endregion

  //region change status invoice
  changeInvoiceStatus({ commit }, payload) {
    return apiClient
      .put(`api/invoicing/${payload.invoice_id}/status`, payload.form_data)
      .then((response) => {
        commit('auth/setErrors', {}, { root: true })
        commit('setInvoice', response.data.data)
        return response.data
      })
  },
  //endregion

  //region clone invoice
  cloneInvoice({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return apiClient
      .get(`api/invoicing/clone/${payload.invoice_id}`)
      .then((response) => {
        commit('setInvoice', response.data.data)
        router.push({
          name: 'invoice_info_route',
          params: { invoicing_id: response.data.data.id }
        })
        return response.data
      })
  },
  //endregion

  //region convert invoice
  convertInvoice({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return apiClient
      .get(
        `api/invoicing/clone/${payload.invoice_id}?new_type=${payload.doc_type}`
      )
      .then((response) => {
        commit('setInvoice', response.data.data)
        router.push({
          name: 'invoice_info_route',
          params: { invoicing_id: response.data.data.id }
        })
        return response.data
      })
  },
  //endregion

  //region send invoice
  /** 200 {invoice}, or 422 {message} toasted by apiClient. */
  sendInvoiceViaPeppol({ commit }, payload) {
    return apiClient
      .post(`api/invoicing/${payload.id}/peppol/send`)
      .then((response) => {
        commit('setInvoice', response.data.invoice)
        return response.data
      })
  },
  sendInvoice(_, payload) {
    return apiClient
      .post(`api/send-invoice`, payload.info)
      .then((response) => response.data)
  },
  //endregion

  async fecthInvoiceExport({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .post(`api/invoicing/accounting-export`, payload, {
        responseType: 'text'
      })
      .then(async (response) => {
        fileDownload(
          response.data,
          'export_factures_' +
            payload.period.from +
            '_' +
            payload.period.to +
            '.csv'
        )
      })
      .catch(() => {})
  },
  async fetchInvoicesCSV({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .post(`api/invoicing/export-csv`, payload, { responseType: 'text' })
      .then(async (response) => {
        fileDownload(
          response.data,
          'CENTRE_FUNERAIRE_GRAND_LITTORAL_IMPRESSION_LISTE_FACTURES.csv'
        )
      })
      .catch((reason) => {
        console.log('fail', reason.response)
        // if (reason.response.status === 422) {
        //   commit('auth/setErrors', reason.response.data.errors.period, { root: true })
        // }
      })
  },
  fetchSendInvoiceMessageTextConverted({ commit }, payload) {
    return apiClient
      .post(`api/convertMessageText`, payload)
      .then((response) => {
        commit('setSendInvoiceMessageText', response.data.text)
        return response.data
      })
  }
}
